function initQuickAdd(context) {
  const container = context || document;

  // ── Hover intent delay ────────────────────────────────────────────────────
  // Adds .is-hovered after 200ms of continuous hover — prevents accidental
  // state changes when the cursor passes quickly over the grid.
  container.querySelectorAll('.product-grid-item').forEach(item => {
    if (item.dataset.hoverBound) return;
    item.dataset.hoverBound = true;

    let hoverTimer = null;

    item.addEventListener('mouseenter', function () {
      hoverTimer = setTimeout(function () {
        item.classList.add('is-hovered');
      }, 200);
    });

    item.addEventListener('mouseleave', function () {
      clearTimeout(hoverTimer);
      // Keep hover state if the panel is open — user is navigating to sizes
      if (!item.classList.contains('expanding')) {
        item.classList.remove('is-hovered');
      }
    });
  });

  // ── Quick Add trigger (expand sizes) ─────────────────────────────────────
  container.querySelectorAll('.quick-add-trigger').forEach(button => {
    if (button.dataset.bound) return;
    button.dataset.bound = true;

    button.addEventListener('click', function (event) {
      event.preventDefault();
      const parent = button.closest('.product-grid-item');
      const sizes = parent.querySelector('.product-sizes');

      sizes.classList.toggle('expanded');
      parent.classList.toggle('expanding');
      sizes.querySelectorAll('.quick-add-size').forEach(el => el.classList.remove('dim'));

      button.classList.toggle('collapsed');
    });
  });

  // ── Size buttons ──────────────────────────────────────────────────────────
  container.querySelectorAll('.quick-add-size').forEach(sizeBtn => {
    if (sizeBtn.dataset.bound) return;
    sizeBtn.dataset.bound = true;

    sizeBtn.addEventListener('mouseenter', function () {
      const parent = this.closest('.product-grid-item');
      if (!parent.classList.contains('expanding')) return;
      const siblings = this.closest('.product-sizes').querySelectorAll('.quick-add-size');
      siblings.forEach(el => el.classList.add('dim'));
      this.classList.remove('dim');
    });

    sizeBtn.addEventListener('mouseleave', function () {
      const parent = this.closest('.product-grid-item');
      if (!parent.classList.contains('expanding')) return;
      const siblings = this.closest('.product-sizes').querySelectorAll('.quick-add-size');
      siblings.forEach(el => el.classList.remove('dim'));
    });

    sizeBtn.addEventListener('click', function () {
      const variantId = this.getAttribute('data-variant-id');
      const self = this;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(response => response.json())
      .then(function (data) {
        const parent = self.closest('.product-grid-item');
        const sizes = parent.querySelector('.product-sizes');

        // Hide sizes, show "Added" label in the same flex row position
        sizes.querySelectorAll('.quick-add-size').forEach(el => el.classList.remove('dim'));
        parent.classList.add('added-state');

        // Open cart drawer after a beat so "Added" is seen first
        setTimeout(function () {
          if (typeof window.openCartDrawer === 'function') {
            window.openCartDrawer();
          }
        }, 650);

        // Collapse expanded state after "Added" has been seen
        setTimeout(function () {
          parent.classList.remove('expanding', 'is-hovered', 'added-state');
          sizes.classList.remove('expanded');
          sizes.querySelectorAll('.quick-add-size').forEach(el => {
            el.classList.remove('dim');
          });
          const trigger = parent.querySelector('.quick-add-trigger');
          if (trigger) trigger.classList.remove('collapsed');
        }, 1600);
      })
      .catch(error => console.error('Error adding to cart:', error));
    });
  });
}

// Run on normal page load
document.addEventListener('DOMContentLoaded', function () {
  initQuickAdd();
});

// Run after Shopify section loads (theme editor / dynamic sections)
document.addEventListener('shopify:section:load', function (e) {
  initQuickAdd(e.target);
});
